import type { FaireProductEntity } from "../../entity_types/product";

export const p_s8r619v: FaireProductEntity = {
  token: "p_s8r619v",
  type: "product",
  name: "Hibiscus Cactus Body Polish",
  brandName: "Nopalera",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/81e61382f9157e0e28a8c44c69ac1859d7a16c4524e699b09c8a4d39c773bdf5.webp",
  priceDollars: 26,
  description: "Hibiscus cactus body polish - Nopalera bestseller",
  categoryTokens: ["cat_bath-all"],
  tags: ["premium", "organic", "bestseller", "body-polish"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/81e61382f9157e0e28a8c44c69ac1859d7a16c4524e699b09c8a4d39c773bdf5.webp",
  weight: 0.6,
  dimensions: {
    width: 3,
    height: 5,
    depth: 2,
  },
  inStock: true,
};
